import {BoltKeyMap,boltColor} from './bolt'

const ColorToStyle = {
  Green: {backgroundColor:'#4CAF50',color:'#FFF'},
  Yellow: {backgroundColor:'#FFEB3B',color:'#777'},
  Red:{backgroundColor:'#F44336',color:'#FFF'},
  Blue:{backgroundColor:'#03C',color:'#FFF'},
  Black:{backgroundColor:'#795548',color:'#FFF'},
  Gray:{backgroundColor:'#CCC',color:'#FFF'},
}


export function BoltRender(hotInstance, td, row, col, prop, value){
  let style = ColorToStyle[boltColor(value)] || {backgroundColor:'#FFF',color:'#000'}
  td.style.backgroundColor = style.backgroundColor
  td.style.color = style.color
  td.innerHTML = value || ''
}

export function SafetyRender(hotInstance, td, row, col, prop, value){
  if(value){
    let style = ColorToStyle[boltColor(value)] || {backgroundColor:'#FFF',color:'#000'}
    td.style.backgroundColor = style.backgroundColor
    td.style.color = style.color
  }
  td.innerHTML = value || ''
}

export function IdSorting(sortOrder) {
  return function(a, b) {
    if(sortOrder)
      return a[1] < b[1] ? 1 : -1
    else
      return a[1] > b[1] ? 1 : -1
  }
}


export function IsBolt(bolt){
  return !( bolt==='S_PRE' || bolt==='S_NEXT' || bolt==='CHECK' || bolt==='SLING')
}

export function IsBolt304(bolt){
  return !!(bolt.includes('F304') || bolt.includes('PC_') || bolt.includes('AA'))
}

function getBoltTypeAndDate(key){
  let type = key.split('_')[0]
  if(type === 'CHECK' || type === 'S' || type === 'SLING')
    return {type:key,name:BoltKeyMap[key]}

  let date = key.split('_')[1]
  let name = BoltKeyMap[type]
  if(!date || date==='XX' || date==='?')
    return {type,name}

  return {type,name,date:'20'+date}
}


export function parseBoltData(data){
  if(!data)
    return {}

  data = data.split('\n')
  let {type,date,name} = getBoltTypeAndDate(data[0])
  if(!data[1])
    return {type,date,name}

  let testDate = data[2]
  data = data[1].toLowerCase()
  let strength = parseInt(data.split('kn')[0])
  let status = data.split(' ')[1]
  let notes

  if(status !=='ok')
    notes = status

  if(status ==='bad' ||status ==='brk')
    notes = '拉力下降'

  if(status ==='out')
    notes = '膠異常拉出'

  if(status ==='wr')
    notes = '變形'

  if(strength <4)
    notes = '直接拉斷'

  if(strength >=4 && strength <8)
    notes = '拉力下降/直接拉斷'

  status = (status ==='ok') ? '合格' : '不合格'

  return {type,name,date,strength,status,notes,testDate}

}




/** WEBPACK FOOTER **
 ** ./src/app/utils/table.js
 **/